import { Label } from 'components/Toolkit/Inputs/Label';
import type { ISectionBrowserProps } from 'components/SearchPage/components/SectionBrowser/SectionBrowser';
import { SectionBrowser } from 'components/SearchPage/components/SectionBrowser/SectionBrowser';
import { Spacer } from 'components/SearchPage/styles';

export interface ISectionBrowserPanelProps extends ISectionBrowserProps {}

function SectionBrowserPanel({ ...rest }: ISectionBrowserPanelProps) {
  return (
    <div>
      <Label variant="COMFORT">Section</Label>
      <SectionBrowser collapsible={true} {...rest} />
      <Spacer />
    </div>
  );
}

export { SectionBrowserPanel };
